import React, { useEffect } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import OurServices from "../home/OurServices";
import Testimonials from "../about/Testimonials";
import HeroSection from "../../layout/HeroSection";
import Loader from "../../components/other/Loader";
import { pageRoutes } from "../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import { fetchServices } from "../../redux/action/homeAction";

const Services = () => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.homeReducer);

  useEffect(() => {
    dispatch(fetchServices());
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      <Header />
      <HeroSection
        label={<h1 class="mb-3">{"Services"}</h1>}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}/` },
          {
            name: "Services",
            path: `${pageRoutes?.home}/`,
          },
        ]}
        subtitle="Some people dream of teaching the World. We're making it happen."
      />
      <OurServices isHeader={false} />
      {/* <Testimonials /> */}
      <Footer />
    </div>
  );
};

export default Services;
